import { useContext, useMemo } from 'react';
import AccordionContext from '../context/accordion-context';

function useOpenStatus(itemId) {
  const { openedItems } = useContext(AccordionContext);
  return useMemo(() => openedItems?.includes(itemId), [openedItems, itemId]);
}

export default useOpenStatus;
